import React from "react";
import { Autocomplete, TextField, Checkbox, Button, Chip } from "@mui/material";

const ValueBookiesFilter = ({
  bookmakers,
  selectedBookmakers,
  onBookmakersChange,
  size = "medium",
}) => {
  const bookmakerOptions = Object.keys(bookmakers);

  const handleSelectAllToggle = () => {
    if (selectedBookmakers.length === bookmakerOptions.length) {
      onBookmakersChange([]);
    } else {
      onBookmakersChange(bookmakerOptions);
    }
  };

  const renderTags = (value, getTagProps) =>
    value.length > 2
      ? [
          ...value
            .slice(0, 2)
            .map((option, index) => (
              <Chip
                key={option}
                {...getTagProps({ index })}
                label={option}
                size="small"
              />
            )),
          <Chip key="more" label={`+${value.length - 2} more`} size="small" />,
        ]
      : value.map((option, index) => (
          <Chip
            key={option}
            {...getTagProps({ index })}
            label={option}
            size="small"
          />
        ));

  return (
    <Autocomplete
      multiple
      size={size}
      sx={{ width: "100%" }}
      options={bookmakerOptions}
      value={selectedBookmakers}
      onChange={(event, newValue) => onBookmakersChange(newValue)}
      disableCloseOnSelect
      getOptionLabel={(option) => option}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox checked={selected} />
          {option}
        </li>
      )}
      renderTags={renderTags}
      renderInput={(params) => (
        <TextField
          {...params}
          size={size}
          label="Bookmakers"
          placeholder="Select bookmakers"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {params.InputProps.endAdornment}
                {selectedBookmakers.length !== bookmakerOptions.length && (
                  <Button
                    onClick={handleSelectAllToggle}
                    size="small"
                    sx={{
                      minWidth: "auto",
                      px: 0.75,
                      py: 0,
                      fontSize: "0.7rem",
                      lineHeight: 1.5,
                      textTransform: "none",
                      fontWeight: 600,
                    }}
                  >
                    All
                  </Button>
                )}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default ValueBookiesFilter;
